<script>
  export default {
    props: {
      defaultText: {
        type: String,
      },
      icon: {
        type: String,
        default: "close",
      },
    },
  };
</script>

<template>
  <div class="areaSelected">
    <iconic class="areaSelected__iconAllow" :name="icon" />
  </div>
</template>

<style lang="scss">
  .areaSelected {
    display: flex;
    gap: 5px;
    &__CheckAreaName {
      display: inline-block;
      text-align: center;
      width: 7rem;
      padding: 0.2rem;
      text-transform: capitalize;
      border-radius: 1rem;
      background: rgba(238, 238, 238, 1);
    }
  }

  .areaSelected {
    &__iconAllow {
      font-size: 10px;
    }
  }
</style>
